import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Magicwand = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M29 14H27C26.45 14 26 13.55 26 13C26 12.45 26.45 12 27 12H29C29.55 12 30 12.45 30 13C30 13.55 29.55 14 29 14Z" />
		<path d="M24 12C24 11.2 23.687 10.45 23.125 9.875L22.125 8.875C21.562 8.312 20.8 8 20 8C19.2 8 18.45 8.313 17.875 8.875L4.875 21.875C4.312 22.438 4 23.2 4 24C4 24.8 4.313 25.55 4.875 26.125L5.875 27.125C6.438 27.688 7.2 28 8 28C8.8 28 9.55 27.687 10.125 27.125L20.837 16.413L23.125 14.126C23.688 13.551 24 12.801 24 12.001V12ZM8.713 25.712C8.525 25.9 8.275 26 8 26C7.725 26 7.487 25.9 7.287 25.712L6.287 24.712C6.099 24.524 6 24.274 6 24C6 23.726 6.1 23.488 6.287 23.288L16.299 13.276L18.712 15.688L8.712 25.713L8.713 25.712ZM21.712 12.713L20.137 14.288L17.724 11.876L19.299 10.301C19.487 10.113 19.737 10.014 20.011 10.014C20.285 10.014 20.523 10.114 20.723 10.301L21.723 11.301C21.911 11.489 22.011 11.739 22.011 12.014C22.011 12.289 21.898 12.514 21.711 12.714L21.712 12.713Z" />
		<path d="M25 22C25.55 22 26 21.55 26 21C26 20.725 25.887 20.475 25.712 20.288L23.712 18.288C23.537 18.113 23.287 18 23 18C22.45 18 22 18.45 22 19C22 19.275 22.113 19.525 22.288 19.712L24.288 21.712C24.476 21.887 24.726 22 25 22Z" />
		<path d="M13 10C13.55 10 14 9.55 14 9C14 8.725 13.887 8.475 13.713 8.287L11.713 6.287C11.525 6.112 11.275 6 11 6C10.45 6 10 6.45 10 7C10 7.275 10.113 7.525 10.287 7.713L12.287 9.713C12.475 9.888 12.725 10 13 10V10Z" />
		<path d="M28 5C28 4.45 27.55 4 27 4C26.725 4 26.475 4.112 26.288 4.287L24.288 6.287C24.113 6.462 24 6.712 24 7C24 7.55 24.45 8 25 8C25.275 8 25.525 7.888 25.712 7.713L27.712 5.713C27.887 5.525 28 5.275 28 5Z" />
		<path d="M19 6C18.45 6 18 5.55 18 5V3C18 2.45 18.45 2 19 2C19.55 2 20 2.45 20 3V5C20 5.55 19.55 6 19 6Z" />
	</svg>
);

export default Magicwand;
